<template>

  <div class="cardWrapper">
    <div :tabindex="tabIndex" @keypress="openNewsArticle(newsURL)" class="cardInner">

      <img :src="imageLink" class="newsCardImage" @click="openNewsArticle(newsURL)" alt="New story cover image" />

      <p class="date-line"><strong>{{ this.newsCat }}</strong> {{ this.newsDate }}</p>

      <div class="dash"
      :class="{ newsDash: this.newsCat === 'News',
                awardsDash: this.newsCat === 'Awards',
                pressDash: this.newsCat === 'Press',}">&nbsp;</div>

      <p class="tag" @click="openNewsArticle(newsURL)" >{{ this.newsTitle }}</p>
      <p class="cont" v-html="this.newsPreview"></p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'RareNewsCard',
  data() {
    return {
      imageLink: null,
    };
  },
  props: {
    newsID: {
      type: String,
      required: true,
    },
    newsURL: {
      type: String,
      required: true,
    },
    newsCat: {
      type: String,
      required: true,
    },
    newsDate: {
      type: String,
      required: true,
    },
    newsImage: {
      type: String,
      required: true,
    },
    newsTitle: {
      type: String,
      required: true,
    },
    newsTag: {
      type: String,
      required: true,
    },
    newsPreview: {
      type: String,
      required: true,
    },
    newsCont: {
      type: String,
      required: true,
    },
    tabIndex: {
      type: String,
      required: true,
    },
  },
  methods: {
    openNewsArticle(newsURL) {
      this.$emit('openNewsArticle', newsURL);
    },
    loadImage() {
      // eslint-disable-next-line
      this.imageLink = require(`@/assets/img/news/thumbs/${this.newsImage}`);
    },
  },
  mounted() {
    this.loadImage();
  },
  updated() {
    this.loadImage();
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .cardWrapper {
    cursor: pointer;
    margin: 0 auto 64px auto;
    width: 100%;
  }

  .cardInner {
    width: 100%;
    padding: 0;
  }

  p.date-line {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p.date-line strong {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    text-transform: capitalize;
  }

  p.tag {
    cursor: pointer;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p.tag:hover {
    text-decoration: underline;
  }

  p.cont {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .dash {
    display: inline-block;
    width: 40px;
    height: 4px;
    padding: 0;
    line-height: 4px;
  }

  .newsDash {
    background-color: #d1a66f;
  }
  .awardsDash {
    background-color: #50e3c2;
  }
  .pressDash {
    background-color: #ff495c;
  }


  @media only screen and (max-width: 640px)  {

    .cardWrapper {
      max-width: 272px;
    }

    .newsCardImage {
      height: auto;
      cursor: pointer;
      max-width: 272px;
    }

    .dash {
      margin: 0 0 0 0;
    }

    p.date-line {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.71;
      letter-spacing: 0.2px;
      margin: 16px 0 3px 0;
    }

    p.date-line strong {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 0.2px;
    }

    p.tag {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 0.2px;
      margin-bottom: 8px;
    }

    p.cont {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 0.2px;
    }

  }

  @media only screen and (min-width: 641px)  {

    .cardWrapper {
      max-width: 376px;
    }

    .newsCardImage {
      height: auto;
      cursor: pointer;
      max-width: 376px;
    }

    .dash {
      margin: 0 0 10px 0;
    }


    p.date-line {
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
      margin: 26px 0 0 0;
    }

    p.date-line strong {
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.5px;
    }

    p.tag {
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.5px;
      margin-bottom: 16px;
    }

    p.cont {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 0.4px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/pages/news/components/RareNewsCard.vue